/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.S30PLUS_INDEX = {

  '@21': 
  [
     215,
  ],
  '@22': 
  [
     220,
     222,
     225,
  ],
  '@23': 
  [
     230,
  ],
};

/* This file is automatically generated, do not edit manually! */
